import { Item } from '../../domain/item';
import { RapidCaptureRecord } from './rapidCaptureTypes';

export const isMatchingRapidCaptureItem = (
  record: RapidCaptureRecord,
  item: Item | undefined,
): item is Item =>
  Boolean(
    item &&
    item.id === record.itemId &&
    item.collectionId === record.collectionId &&
    item.captureOperationId === record.operationId,
  );

export const isRapidCaptureAuthoritativelyConfirmed = (
  record: RapidCaptureRecord,
  item: Item | undefined,
): boolean =>
  isMatchingRapidCaptureItem(record, item) && record.state === 'confirming';

export const shouldReconcileRapidCaptureRecord = (
  record: RapidCaptureRecord,
  item: Item | undefined,
): boolean => {
  // Schema 5 persists this receipt only after the server atomically publishes
  // the item. Inventory loading must not delay clearing a completed capture.
  if (
    record.schemaVersion === 5 &&
    record.state === 'confirming' &&
    record.itemCreated &&
    (record.completion === 'item' || record.completion === 'analysis-complete')
  )
    return true;
  return isRapidCaptureAuthoritativelyConfirmed(record, item);
};
